/**
 * Testimonials — Quantum Star Marketing.
 *
 * You can edit these on the live site at /admin (passcode: quantum2025) — they
 * sync to your browser's localStorage. To make a change permanent for every
 * visitor, edit this file and redeploy.
 */

export const REVIEW_AGGREGATE = {
  rating: 4.2,
  count: 250,
  label: "engagements",
};

const TESTIMONIALS = [
  {
    quote:
      "We came to Quantum Star burning AED 80K/month on Meta with a 1.7x ROAS. Within 90 days we were at 5.4x — same spend, almost 3x revenue. The creative-testing engine alone was worth the entire engagement.",
    name: "Founder",
    role: "DTC Skincare Brand · Dubai",
  },
  {
    quote:
      "The team rebuilt our entire SEO foundation. Eleven months in we're ranking in the top 3 for our money keywords in both English and Arabic. Cost per lead is 70% lower than our Google Ads spend.",
    name: "Head of Marketing",
    role: "Healthcare Clinic Network · UAE",
  },
  {
    quote:
      "Their AI chatbot now handles 68% of our WhatsApp enquiries end-to-end, books site visits straight into the calendar, and sends only qualified leads to my agents. It paid for itself in week 2.",
    name: "Managing Director",
    role: "Real Estate Brokerage · Dubai",
  },
  {
    quote:
      "We replaced four separate agencies (SEO, paid, email, social) with Quantum Star and our blended CAC dropped 38% in the first quarter. One team, one dashboard, one P&L. That's the difference.",
    name: "Co-founder",
    role: "B2B SaaS · MENA-focused",
  },
  {
    quote:
      "The branding overhaul was the most strategic work I've ever commissioned. We raised our pricing by 35% the week we launched — and our close rate went up, not down. Brand pays.",
    name: "Founder & CEO",
    role: "Luxury F&B Group · UAE",
  },
  {
    quote:
      "Their funnel architecture took our high-ticket consulting offer from a 4% booked-call rate to 11.5%. Same traffic, same offer, 3x conversions. The Slack updates alone make them feel in-house.",
    name: "Founder",
    role: "Management Consultancy · GCC",
  },
  {
    quote:
      "We were sceptical about TikTok for our category. They proved us wrong — 2.3M organic views in 60 days and 14K new followers, with measurable lifts in branded search and Shopify revenue.",
    name: "Marketing Director",
    role: "Modest-Fashion DTC · Saudi Arabia",
  },
  {
    quote:
      "I've used 6 SaaS growth agencies in my career. Quantum Star is the first one that ran experiments fast enough to keep up with our roadmap and reported in metrics our board actually cares about.",
    name: "VP Growth",
    role: "Series B Vertical SaaS · Dubai",
  },
  {
    quote:
      "The bilingual content engine has been the unlock — we finally have a real Arabic-speaking audience. Our LinkedIn following more than doubled, and three of our largest clients came inbound from that content.",
    name: "Founder",
    role: "Wealth & Financial Advisory · DIFC",
  },
  {
    quote:
      "The Amazon ad restructure cut our TACoS from 28% to 14% in six weeks. We're now category-leader for our money keyword in the UAE and starting expansion to Saudi.",
    name: "E-commerce Lead",
    role: "Home & Living DTC · UAE",
  },
];

export default TESTIMONIALS;
